import React from 'react';
import SEO from '../components/seo';
// import ProjectSliderMonto from '../components/projects/projectSliderMonto';
// import ProjectSliderLemosta from '../components/projects/projectSliderLemosta';
import ProjectSliderHero from '../components/projects/projectSliderHero';
// import { HashLink } from 'react-router-hash-link';
// import $ from 'jquery';

const ProjectPageHero = () => {
  return (
    <>
      <SEO title="HERO Feeling Salon | Our Projects" />
      <section className="projectVisual">
        <h1 className="visual--title">
          <span>Our</span> Projects
        </h1>
        <p className="visual--desc">
          全人類の健康をアップデートさせるべく
          <br />
          サイレンサーが展開するプロジェクト。
        </p>
      </section>
      <section className="projectWrap">
        {/* ////////////区切り線//////////// */}
        <div className="projectBox" id="p4">
          <h2 className="projectName">HERO Feeling Salon</h2>
          <p className="projectCopy">
            CS60/オイルリラクゼーション+頭蓋仙骨法/よもぎ蒸し/RIFE
            LIFE/毛髪ミネラル検査。深いヒアリングから導き出される、日々の生活の中で万病の温床になっている身体の電子情報のエラーを最適化し、人間本来の自然治癒力と免疫機能をGOKIGENへ
          </p>
          <div className="projectSlider--wrap">
            <ProjectSliderHero />
          </div>
          {/* <h3 className="projectOverview"></h3> */}
          <h3 className="projectOverview">あたらしい心身ゼロ地点へ</h3>
          {/* <h3 className="projectOverview"></h3> */}
          <div className="projectText">
            <p>あたらしいZEROへ。</p>
            <p>
              一方的な価値観。一方的な情報。一方的なあり方。そんな無批判であまりに偏りすぎた思考が横たわる現代社会。
            </p>
            <p>
              窮屈で、その崩れた軸を失った身体バランスは心身への不調へと繋がっている。
              <br />
              ネガティブなニュースが連日報じられ日々の自分の大切な「上機嫌」の軸さえメディアにコントロールされてはいないだろうか？
            </p>
            <p>
              そうした日々の中で大きく偏ったマインドとフィジカルの座標軸は健やかなゼロ地点を遠く離れ、それは必ず様々な形でメッセージとして身体に現れる。
            </p>
            <p>過剰にはマイナスを、不足にはプラスを。</p>
            <p>HEROで整えられるのは身体の隔たった電子情報の最適化。</p>
            <p>
              それは原点回帰ではない。
              <br />
              あたらしくサスティナブルなZERO地点への着地のための軌道修正となる。
            </p>
            <p>わたしたちの未来は自身の内側にある。</p>
          </div>
          <ul className="projectLink">
            <li>
              <a
                href="https://www.instagram.com/hero_feeling_salon/?hl=ja"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default ProjectPageHero;
